import OrderConfigProvider from "./Context/OrderConfigContext";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import Store from "./Context/Store";
import reportWebVitals from "./reportWebVitals";

import * as Sentry from "@sentry/react";
/*
ignoreErrors:
REsizeObserver loop error added in ignore list base on below finding
https://stackoverflow.com/questions/49384120/resizeobserver-loop-limit-exceeded
*/

Sentry.init({
  ignoreErrors: [
    "ResizeObserver loop limit exceeded"
  ],
  dsn: process.env.REACT_APP_SENTRY_DSN,
  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  release: "frenchflorist-v2-web-admin",
  environment: process.env.REACT_APP_SENTRY_ENVIRONMENT,
  tracesSampleRate: 0.0,
  integrations: [Sentry.browserTracingIntegration()],
});

// React 19 new root API
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Sentry.ErrorBoundary fallback={"An error has occurred"}>
    <Store>
      <OrderConfigProvider>
        <App />
      </OrderConfigProvider>
    </Store>
  </Sentry.ErrorBoundary>
);
// ReactDOM.render(<React.StrictMode> <App /> </React.StrictMode>, document.getElementById('root'));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
